<i (click)="loadSitter(); op.toggle($event)" *ngIf="id" class="pi pi-info-circle"
   style="cursor: pointer; margin-left: 2px;color:darkgrey"></i>


<p-overlayPanel #op>
  <ng-template pTemplate>
    <div *ngIf="sitter">
      <app-sitter-small-detail [sitter]="sitter"></app-sitter-small-detail>
    </div>
  </ng-template>
</p-overlayPanel>
